import { useRef, useState } from 'react'
import { Button, Input, Space, Select } from 'antd'
import { SearchOutlined } from '@ant-design/icons'
import omit from 'lodash/omit'

const useTableFilter = () => {
  const [searchText, setSearchText] = useState('')
  const [searchedColumn, setSearchedColumn] = useState('')
  const [filter, setFilter] = useState({})
  const searchInput = useRef(null)

  const handleSearch = (selectedKeys, confirm, dataIndex) => {
    setSearchText(selectedKeys[0])
    setSearchedColumn(dataIndex)
    setFilter((prev) => ({ ...prev, [dataIndex]: selectedKeys[0] }))
    confirm()
  }

  const handleReset = (clearFilters, confirm, dataIndex) => {
    clearFilters()
    setSearchText('')
    setFilter((prev) => omit(prev, dataIndex))
    confirm()
  }

  const getColumnSearchProps = (dataIndex, options) => ({
    filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
      <div
        style={{
          padding: 8,
        }}
      >
        {options ? (
          <Select
            options={options}
            value={selectedKeys}
            dropdownMatchSelectWidth={false}
            onChange={(v) => {
              setSelectedKeys(v ? [v] : [])
              const labels = options.filter((item) => item.value === v).map((item) => item.label)
              handleSearch(labels, confirm, dataIndex)
            }}
            showSearch
            style={{
              marginBottom: 8,
              display: 'block',
            }}
          />
        ) : (
          <Input
            ref={searchInput}
            placeholder="Введите фразу"
            value={selectedKeys[0]}
            onChange={(e) => setSelectedKeys(e.target.value ? [e.target.value] : [])}
            onPressEnter={() => handleSearch(selectedKeys, confirm, dataIndex)}
            style={{
              marginBottom: 8,
              display: 'block',
            }}
          />
        )}
        <Space>
          <Button
            type="primary"
            onClick={() => handleSearch(selectedKeys, confirm, dataIndex)}
            icon={<SearchOutlined />}
            size="small"
            style={{
              width: 90,
            }}
          >
            Найти
          </Button>
          <Button
            onClick={() => clearFilters && handleReset(clearFilters, confirm, dataIndex)}
            size="small"
            style={{
              width: 90,
            }}
          >
            Сбросить
          </Button>
        </Space>
      </div>
    ),
    filterIcon: (filtered) => (
      <SearchOutlined
        style={{
          color: filtered ? '#1890ff' : undefined,
          marginRight: 10,
        }}
      />
    ),
    onFilterDropdownVisibleChange: (visible) => {
      if (visible) {
        setTimeout(() => searchInput.current?.select(), 100)
      }
    },
  })

  return [filter, searchText, searchedColumn, getColumnSearchProps]
}

export default useTableFilter
